import { valueOf } from "@/types/common";

export const RENEW_VISA_LIST_TAB = {
  NOT_CREATED_AND_IN_PROGRESS: "not_created_and_in_progress",
  UNDER_REVIEW_AND_APPROVED: "under_review_and_approved",
  COMPLETE_AND_WITHDRAWN_AND_REJECTED: "complete_and_withdrawn_and_rejected",
};

export type TRenewVisaListTab = valueOf<typeof RENEW_VISA_LIST_TAB>;

export const RENEW_VISA_LIST_TAB_LABEL = {
  [RENEW_VISA_LIST_TAB.NOT_CREATED_AND_IN_PROGRESS]: "申請準備",
  [RENEW_VISA_LIST_TAB.UNDER_REVIEW_AND_APPROVED]: "申請中",
  [RENEW_VISA_LIST_TAB.COMPLETE_AND_WITHDRAWN_AND_REJECTED]: "過去提出分",
};
